<template>
    <div class="about-box">

        <div class="about-info-box">
            <div class="bg-card"></div>
            <div class="about-card">
                <div class="term">公司简介
                </div>
                <div class="text"> 呼和浩特市YOBONKE信通创立于2025年9月，是一家由一群纯技术人员建立的、
                    创新的电话通信技术高科技企业。

                </div>

                <div class="text">
                    YOBONKE信通以创新的运营模式，为客户提供精准的电话通信数据、高效的电话
                    通信模式。帮助客户管理其复杂的客户联络数据，给企业提高沟通与协作方面的效率，
                    让企业更加提升行业竞争力。
                </div>

            </div>
        </div>


        <div class="develop-box">
            <div class="develop-card">
                <div class="year-term">2021</div>
                <div class="month-list-term">

                    <div class="item-box">
                        <div class="month">05月</div>
                        <div class="info">深圳市云智信通科技有限公司成立。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">07月</div>
                        <div class="info">推出YOBONKE电话助手软件第一个版本，第一个版本，仅仅有IP-PBX的CTI接口，可以 实现CTI电脑拨号，通信录，来去电弹屏，通话记录，沟通摘要记录。
                        </div>
                    </div>
                    <div class="item-box">
                        <div class="month">08月</div>
                        <div class="info">YOBONKE第二个版本，增加USB话机拨号，集成IP话机的URL action拨号。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">09月</div>
                        <div class="info">YOBONKE第三个版本，增加鼠标屏幕取号，增加批量外呼任务的自动外呼功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">10月</div>
                        <div class="info">YOBONKE第四个版本，增加挂机短信功能，增加第三方CRM弹屏功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">11月</div>
                        <div class="info">YOBONKE第五个版本，增加Mysql数据存储功能，实现数据后台集中管理。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">12月</div>
                        <div class="info">YOBONKE Version2.4版本，增加录音上传，集中存储管理功能。</div>
                    </div>



                </div>
            </div>
            <div class="develop-card">
                <div class="year-term">2022</div>
                <div class="month-list-term">










                    <div class="item-box">
                        <div class="month">03月</div>
                        <div class="info">深圳市云智信通科技有限公司成立。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">04月</div>
                        <div class="info">推出YOBONKE电话助手软件第一个版本，第N个版本，仅仅有IP-PBX的CTI接口。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">05月</div>
                        <div class="info">YOBONKE第二个版本，增加USB话机拨号，集成IP话机的URL action拨号。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">06月</div>
                        <div class="info">YOBONKE第三个版本，增加鼠标屏幕取号，增加批量外呼任务的自动外呼功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">07月</div>
                        <div class="info">YOBONKE第四个版本，增加挂机短信功能，增加第三方CRM弹屏功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">08月</div>
                        <div class="info">YOBONKE第五个版本，增加Mysql数据存储功能，实现数据后台集中管理。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">09月</div>
                        <div class="info">YOBONKE Version2.6版本，增加录音上传，集中存储管理功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">10月</div>
                        <div class="info">YOBONKE Version2.7版本，增加挂机短信功能，增加第三方CRM弹屏功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">11月</div>
                        <div class="info">YOBONKE Version2.8版本，增加Mysql数据存储功能，实现数据后台集中管理。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">12月</div>
                        <div class="info">YOBONKE Version2.9版本，增加录音上传，集中存储管理功能。</div>
                    </div>

                </div>
            </div>
            <div class="develop-card">
                <div class="year-term">2023</div>
                <div class="month-list-term">





                    <div class="item-box">
                        <div class="month">03月</div>
                        <div class="info">YOBONKE电话助手软件获取国家计算机软件著作权。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">04月</div>
                        <div class="info">YOBONKE获得国家商标证书。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">05月</div>
                        <div class="info">YOBONKE Version3，增加sip软电话功能，实现sip网络电话电脑软电话功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">06月</div>
                        <div class="info">推出支持websocket版本的YOBONKE，通过websocket对接第三方CRM，实现呼叫中心的功能。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">07月</div>
                        <div class="info">推出AI语音总机，AI语音导航转接功能。</div>
                    </div>

                </div>
            </div>
            <div class="develop-card">
                <div class="year-term">2024</div>
                <div class="month-list-term">



                    <div class="item-box">
                        <div class="month">05月</div>
                        <div class="info">出AI智能电销产品，实现人机配合的智能电销。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">06月</div>
                        <div class="info">推出YOBONKE Version5,手机坐席外呼管理系统产品。</div>
                    </div>
                    <div class="item-box">
                        <div class="month">07月</div>
                        <div class="info">手机坐席系统产品，增加CRM功能，实现手机坐席呼叫中心功能。</div>
                    </div>

                </div>
            </div>

        </div>
        <div class="about-vision-box">
            <div class="vision-card">
                <div class="left-img">
                    <img src="@/assets/image/about/vision.jpg" alt="">
                </div>
                <div class="right-text">
                    <div class="term">公司愿景
                    </div>
                    <div class="text"> 不在乎那些B2C、C2C还是O2C，始终坚持免费试用会员付费。
                    </div>
                    <div class="text">
                        拒绝一切资本介入，因为资本介入后会让我们的产品价值变质。
                    </div>
                    <div class="text">
                        没有销售团队，更没有广告宣传，也没有营销渠道，坚持低成本运作，0销售成本用心做好自己的产品，利润是顺基自然的事情，始终坚持口碑营销策略，大规模的营销推广销售渠道仅仅是昙花一现。
                    </div>
                </div>
            </div>
        </div>

        <div class="product-list">
            <div class="term">
                <div class="text">产品列表</div>
                <div class="underline"></div>
            </div>
            <div class="product-bg">
                <div class="free-produ">
                    <div class="term">YOBONKE产品
                    </div>
                    <div class="free-btn">免费试用</div>
                </div>
                <div class="use1">
                    <div>YOBONKE</div>
                    <div>电话软件助手</div>
                </div>
                <div class="use2">
                    <div>AI智能
                    </div>
                    <div>语音总机
                    </div>
                </div>
                <div class="use3">
                    <div>手机坐席
                    </div>
                    <div>外呼系统
                    </div>
                </div>
                <div class="use4">
                    <div>YOBONKE</div>
                    <div>
                        云电话管理系统
                    </div>
                </div>
                <div class="use5">
                    <div>AI智能
                    </div>
                    <div>电销系统
                    </div>
                </div>
                <div class="use6">
                    <div>手机CRM
                    </div>
                    <div>呼叫中心系统
                    </div>
                </div>
            </div>
        </div>

        <div class="product-list honor-box">
            <div class="term">
                <div class="text">企业荣誉</div>
                <div class="underline"></div>
            </div>

            <div class="card-list-box">
                <div class="row-card">
                    <div class="item-card">
                        <div class="honor-card">
                            <img src="@/assets/image/about/honor1.png" alt="">
                        </div>
                        <div class="honor-name">计算机软件著作
                        </div>
                        <div class="honor-text">YOBONKE电话助手
                        </div>
                    </div>
                    <div class="item-card">
                        <div class="honor-card">
                            <img src="@/assets/image/about/honor2.png" alt="">
                        </div>
                        <div class="honor-name">手机app软件著作

                        </div>
                        <div class="honor-text">YOBONKE手机app

                        </div>
                    </div>
                    <div class="item-card">
                        <div class="honor-card">
                            <img src="@/assets/image/about/honor3.png" alt="">
                        </div>
                        <div class="honor-name">营业执照

                        </div>
                        <div class="honor-text">呼和浩特市YOBONKE
                            科技有限公司
                        </div>
                    </div>
                </div>
                <div class="row-card" style="padding: 0 690px;">
                    <div class="item-card">
                        <div class="honor-card">
                            <img src="@/assets/image/about/honor4.png" alt="">
                        </div>
                        <div class="honor-name">商标注册证
                        </div>
                        <div class="honor-text">YOBONKE电话助手logo

                        </div>
                    </div>
                    <div class="item-card">
                        <div class="honor-card">
                            <img src="@/assets/image/about/honor5.png" alt="">
                        </div>
                        <div class="honor-name">商标注册证
                        </div>
                        <div class="honor-text">YOBONKE电话助手商标
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>


export default {

}
</script>

<style lang="less" scoped>
.about-box {
    .about-info-box {
        height: 500px;
        // background: red;
        background: url('@/assets/image/about/aboutBanner.jpg') no-repeat;
        background-size: 100% 100%;
        position: relative;

        .bg-card {
            z-index: 4;
            position: absolute;
            width: 175px;
            height: 83px;
            background-color: rgba(0, 159, 233, 1);
            left: 314px;
            top: 25px;
        }

        .about-card {
            width: 747px;
            height: 358px;
            background-color: rgba(255, 255, 255, .8);
            position: absolute;
            top: 62px;
            left: 381px;
            z-index: 5;
            padding: 30px;



            .term {
                font-size: 26px;
                font-weight: bold;
                margin-bottom: 20px;
            }

            .text {
                text-indent: 2em;
                line-height: 40px;
            }
        }
    }

    .develop-box {
        background: #efefef;

        .develop-card {
            width: 1060px;
            margin: 0 auto;
            padding: 60px 0;

            .year-term {
                font-size: 26px;
                font-weight: bold;
                margin-bottom: 30px;
            }

            .item-box {
                display: flex;

                font-size: 18px;
                // margin-bottom: 20px;

                &:nth-child(1) {
                    .month {
                        // padding-top: 5px;

                        &::after {
                            // transform: translate(50%, 0px);
                        }
                    }
                }

                .separate {
                    width: 1px;
                    height: 100%;
                    background-color: #bbbbbb;
                    margin: 0 40px;
                }

                .month {
                    border-right: 1px solid #000;
                    padding-right: 40px;
                    margin-right: 40px;
                    position: relative;

                    &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 0;
                        transform: translate(50%, 10px);
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background-color: #009fe9;
                    }
                }

                .info {
                    width: 700px;
                    // background: red;
                    margin-bottom: 20px;
                }


            }


        }
    }

    .about-vision-box {
        height: 450px;
        background-color: #e0dfdf;
        padding: 30px 0;

        .vision-card {
            width: 1060px;
            height: 100%;
            margin: 0 auto;
            display: flex;

            .left-img {
                width: 50%;
                height: 100%;

                // background-color: blue;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .right-text {
                width: 50%;
                height: 100%;
                background: #fff;
                padding: 30px;

                .term {
                    font-size: 26px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .text {
                    text-indent: 2em;
                    line-height: 30px;
                }
            }

        }
    }

    .product-list {
        padding: 50px 0;
        background: #efefef;

        .term {
            .text {
                text-align: center;
                font-size: 36px;
                color: #101010;
                font-weight: bold;
            }

            .underline {
                width: 76px;
                height: 2px;
                background-color: #101010;
                margin: 15px auto 0;
            }
        }

        .product-bg {
            width: 1074px;
            height: 660px;
            margin: 0 auto;
            background: url('@/assets/image/about/productBg.png') no-repeat;
            background-size: 100% 100%;
            position: relative;

            .free-produ {
                position: absolute;
                left: 51%;
                top: 46%;
                transform: translate(-50%, -50%);
                width: 260px;
                height: 260px;
                // background-color: pink;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                padding: 54px 0;

                .term {
                    text-align: center;
                    font-size: 25px;
                }

                .free-btn {
                    width: 140px;
                    height: 44px;
                    background-color: #01b0bb;
                    color: #fff;
                    text-align: center;
                    line-height: 44px;

                }
            }

            .use1,
            .use2,
            .use3,
            .use4,
            .use5,
            .use6 {

                position: absolute;

                width: 120px;
                height: 120px;
                border-radius: 50%;
                text-align: center;
                // line-height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background-color: rgb(255, 255, 255, 0);
                font-size: 16px;
            }

            .use1 {
                top: 87px;
                left: 79px;
            }

            .use2 {
                top: 307px;
                left: 181px;
            }

            .use3 {
                bottom: 23px;
                left: 147px;
            }

            .use4 {
                right: 215px;
                top: 87px;
            }

            .use5 {
                right: 19px;
                top: 302px;
            }

            .use6 {
                right: 182px;
                bottom: 52px;
            }
        }
    }

    .honor-box {
        background-color: #e0dfdf;

        .card-list-box {
            padding: 20px 0;

            .row-card {
                display: flex;
                justify-content: space-evenly;
                padding: 0 570px;
                margin-bottom: 50px;

                .item-card {
                    font-size: 18px;
                    text-align: center;
                    width: 240px;

                    .honor-card {
                        width: 237px;
                        height: 322px;
                        // background: orange;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                    }

                    .honor-name {
                        color: #101010;
                    }

                    .honor-text {
                        color: #747577;
                    }
                }
            }
        }
    }
}
</style>
